import Waypoint from "./Waypoint";

export default class DelayedClassAssignment {

    static get ElementAttribute() {
        return "data-delayed-class";
    }

	items: NodeListOf<HTMLElement>;

    /**
     * @param {NodeListOf<HTMLElement>|null} elements
     */
    constructor(elements = null) {
        if (elements === null) {
            this.items = document.querySelectorAll(`[${DelayedClassAssignment.ElementAttribute}]`);
        }
        else {
            this.items = elements;
        }

        this.items.forEach(this.createHandler.bind(this));
    }

    static updateItemClass(item: HTMLElement): void {
        const delay = Number.parseInt(<string>item.dataset.delay);
        const cls = item.getAttribute(DelayedClassAssignment.ElementAttribute)?.split(" ") || [];
        window.setTimeout(() => {
            cls.forEach(c => {
                item.classList.add(c);
            });
        }, delay);
    }

    createHandler(item: HTMLElement, index: number): void {
        if (!item.getAttribute("data-delay-initialized")) {
            const $parent = item.closest(".waypoint");
            const isWaypoint = $parent !== null;

            item.setAttribute("data-delay-initialized", "");

            if (isWaypoint) {
                $parent.addEventListener(Waypoint.InViewClass, () => {
                    DelayedClassAssignment.updateItemClass(item);
                });

                if ($parent.classList.contains(Waypoint.InViewClass)) {
                    DelayedClassAssignment.updateItemClass(item);
                }
            }
            else {
                DelayedClassAssignment.updateItemClass(item);
            }

        }

    }
}
